





















import { Component, Vue, Prop } from 'vue-property-decorator';
import TradeSellOfferForms from '@/components/trading/trade-selloffer/TradeSellOfferForms.vue';
import { SellOffer } from '@/store/sellOffer/types';
import { Wallet, UserWallet } from '@/store/wallet/types';
import { Getter, Action } from 'vuex-class';
import { Asset } from '@/store/asset/types';


@Component({
  name: 'trade-sell-offer-view',
  components: {
    TradeSellOfferForms,
  },
})
export default class TradeSellOfferView extends Vue {
  @Getter('sellOffer/sellOffer') sellOffer?: SellOffer;
  @Getter('wallet/wallet') wallet?: Wallet;
  @Getter('appState/isLoading') isLoading?: boolean;
  @Getter('wallet/userWallet') userWallet?: UserWallet;
  @Getter('asset/asset') asset: Asset;

  @Action('asset/setAsset') setAsset: any;
  @Action('sellOffer/fetchSellOffer') fetchSellOffer;
  @Action('appState/setRedirectUrl') setRedirectUrl;

  async mounted() {
    const sellOfferId = this.$route.params.sellOfferId;
    const redirectUrl = this.$route.query.redirect_url;
    this.setRedirectUrl(redirectUrl);

    try {
      const responseSellOffer = await this.fetchSellOffer(sellOfferId);
      const { asset } = responseSellOffer.data;

      if (asset) {
        this.setAsset(asset);
      }
    } catch( error ) {
      console.log(error);
    }
    
  }

  get lockedAccount() {
    return !!this.userWallet.locked_at;
  }
}
